import { emailValidator as customerIdentityEmailValidator } from '@havenengineering/module-shared-email-validation';
export const isValidEmail = (value) => {
    return customerIdentityEmailValidator.validate(value).valid;
};
